module.exports = __webpack_public_path__ + "static/media/cq_prima_del_finanziamento.89c1948a.svg";